import React from 'react';
import Weekday from './WeekdayMobile';
import { IHeaderMobile } from './types';

const HeaderMobile: React.FC<IHeaderMobile> = ({ currentMoment }) => {
  if (currentMoment.get('month') === 0) {
    return (
      <>
        <div className="smls-calendar-header-mobile">
          <strong style={{ textTransform: 'capitalize', marginRight: '6px' }}>{currentMoment.format('MMMM')}</strong>
          <span style={{ fontWeight: 400 }}>{currentMoment.format('YYYY')}</span>
        </div>
        <Weekday />
      </>
    );
  }

  return (
    <>
      <strong
        className="smls-calendar-header-mobile"
        style={{ textTransform: 'capitalize' }}
        data-testid="header-mobile-month"
      >
        {currentMoment.format('MMMM')}
      </strong>
      <Weekday />
    </>
  );
};

export default HeaderMobile;
